/**
 * api/designSystemRepositorio.js — Design System EXTRAÍDO DO REPOSITÓRIO (brownfield).
 *
 * Pedido do dono (2026-10-05): em projeto existente com escopo fullstack/frontend, o Design
 * Studio carrega o Design System que já está no repositório indexado; as outras opções
 * continuam como alternativa.
 *
 * GET  /projects/{id}/design-system/repositorio          → estado: {habilitado, aplicavel, motivo,
 *        ds (a extração mais recente | null), ativoId, ativoOrigem, extrairAoAbrir, repositorios}
 * POST /projects/{id}/design-system/repositorio/extrair  → {encontrado, motivo, ds, cobertura,
 *        repositorios} — sem front ou sem token extraível NÃO é erro: vem `encontrado=false`
 * PUT  /projects/{id}/design-system/{dsId}/tokens        → ajusta tokens (nova versão)
 *
 * `ds.repositorio` traz a cobertura, a origem (arquivo/linha/trecho) de cada token, o
 * inventário de componentes, os breakpoints e de qual índice (branch/commit) saiu.
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client';
import { designSystemKey } from './designSystem';

// Prefixo de `designSystemKey`: ativar/remover um DS também atualiza este estado.
export const designSystemRepositorioKey = (projectId) => [...designSystemKey(projectId), 'repositorio'];

/** useDesignSystemDoRepositorio — estado da extração; só consulta em projeto existente. */
export function useDesignSystemDoRepositorio(projectId, { enabled = true } = {}) {
  const api = useApi();
  return useQuery({
    queryKey: designSystemRepositorioKey(projectId),
    queryFn:  () => api.get(`/projects/${projectId}/design-system/repositorio`),
    enabled:  Boolean(projectId) && enabled,
  });
}

/** useExtrairDoRepositorio — lê o front-end do repositório indexado. body: { ativar? }. */
export function useExtrairDoRepositorio(projectId) {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body = {}) => api.post(`/projects/${projectId}/design-system/repositorio/extrair`, body),
    onSuccess:  () => qc.invalidateQueries({ queryKey: designSystemKey(projectId) }),
  });
}

/** useAjustarTokens — { dsId, tokens: {grupo: {chave: valor | null}} } → nova versão do DS. */
export function useAjustarTokens(projectId) {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ dsId, tokens }) => api.put(`/projects/${projectId}/design-system/${dsId}/tokens`, { tokens }),
    onSuccess:  () => qc.invalidateQueries({ queryKey: designSystemKey(projectId) }),
  });
}
